export type BreedSafetyLabel = {
  kind: "dangerous" | "aggression";
  label: "맹견" | "공격성";
  description: string;
};

// 동물보호법 시행규칙 제2조의 품종(및 향후 카탈로그에 추가될 수 있는 표기)을 slug로 관리한다.
const LEGALLY_DANGEROUS_BREEDS = new Set([
  "tosa",
  "tosa-inu",
  "pit-bull-terrier",
  "american-pit-bull-terrier",
  "american-staffordshire-terrier",
  "staffordshire-bull-terrier",
  "rottweiler",
]);

// 법정 맹견은 아니지만 큰 체격과 보호·경계 본능 때문에 숙련된 통제가 특히 필요한 품종이다.
const LARGE_BREEDS_REQUIRING_AGGRESSION_MANAGEMENT = new Set([
  "akita",
  "anatolian-shepherd-dog",
  "belgian-malinois",
  "boerboel",
  "bullmastiff",
  "cane-corso",
  "doberman-pinscher",
  "german-shepherd-dog",
  "giant-schnauzer",
  "neapolitan-mastiff",
  "tibetan-mastiff",
]);

export function getBreedSafetyLabel(slug: string): BreedSafetyLabel | undefined {
  if (LEGALLY_DANGEROUS_BREEDS.has(slug)) {
    return {
      kind: "dangerous",
      label: "맹견",
      description: "대한민국 동물보호법상 맹견 품종(잡종 포함)",
    };
  }
  if (LARGE_BREEDS_REQUIRING_AGGRESSION_MANAGEMENT.has(slug)) {
    return {
      kind: "aggression",
      label: "공격성",
      description: "법정 맹견은 아니며, 대형 보호·경계견 특성상 공격성 관리와 사회화가 특히 필요합니다.",
    };
  }
}
